import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i1202068640__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Häuser / Stadt", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i1202068640__cls-1{fill:none}.i1202068640__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M176 174V66.01c0-1.1-.9-2-2-2h-62.04V176H174c1.1 0 2-.9 2-2m-20.06-37.94h-23.92v-8h23.92zm0-24.04h-23.92v-8h23.92zm0-24h-23.92v-8h23.92zM101.96 16H18c-1.1 0-2 .9-2 2v156c0 1.1.9 2 2 2h37.98v-20.01h8V176h39.98V18c0-1.1-.9-2-2-2M53.97 136.02H30.05v-8h23.92zm0-23.97H30.05v-8h23.92zm0-24.04H30.05v-8h23.92zm0-24H30.05v-8h23.92zm0-24H30.05v-8h23.92zm35.99 96.01H66.04v-8h23.92zm0-23.97H66.04v-8h23.92zm0-24.04H66.04v-8h23.92zm0-24H66.04v-8h23.92zm0-24.01H66.04v-8h23.92z",
      class: "i1202068640__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M66.03 56.01h23.92v8H66.03zM132.02 80.01h23.92v8h-23.92zM132.02 104.02h23.92v8h-23.92z",
      class: "i1202068640__cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M101.96 8H18C12.49 8 8 12.49 8 18v156c0 5.51 4.49 10 10 10h155.99c5.51 0 10-4.49 10-10V66.01c0-5.51-4.49-10-10-10h-62.04V18c0-5.51-4.49-10-10-10Zm10 56.01H174c1.1 0 2 .9 2 2V174c0 1.1-.9 2-2 2h-62.04zm-8 111.99H63.98v-20.01h-8V176H18c-1.1 0-2-.9-2-2V18c0-1.1.9-2 2-2h83.96c1.1 0 2 .9 2 2z",
      class: "i1202068640__cls-2"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("path", {
      d: "M66.03 32h23.92v8H66.03zM30.05 32.01h23.92v8H30.05zM30.05 56.01h23.92v8H30.05zM66.03 80.01h23.92v8H66.03zM30.05 80.01h23.92v8H30.05zM66.03 104.05h23.92v8H66.03zM30.05 104.05h23.92v8H30.05zM66.03 128.02h23.92v8H66.03zM30.05 128.02h23.92v8H30.05zM132.02 128.06h23.92v8h-23.92z",
      class: "i1202068640__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "city"}) } }